module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado10.66afde2c.svg";